const USER_STORAGE_KEY = 'user';

export const getStoredUser = () => {
  try {
    const value = localStorage.getItem(USER_STORAGE_KEY);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    localStorage.removeItem(USER_STORAGE_KEY);
    return null;
  }
};

export const setStoredUser = user => {
  localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
};

export const clearStoredUser = () => {
  localStorage.removeItem(USER_STORAGE_KEY);
};

export const getAccessToken = () => getStoredUser()?.token || null;

export const getStoredIdentity = () => {
  const session = getStoredUser();
  return session?.data?.user || session?.user || null;
};
